export default __webpack_public_path__ + "static/media/geo_dome.0bf8211e.glb";